import { Form } from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";
import { recovery, sendCode } from "../../services/serviceVivetuseguro";

const SidebarPasswordCodigo = ({
  errorData,
  mensaje,
  formCode,
  recaptchaRef,
  setMensaje,
  setSpinner,
  form,
  setErrorData,
  setCount,
  setFormCode,
  urlApi,
  codRecaptcha,
}) => {
  const handleSubmitCodigo = async (e) => {
    e.preventDefault();

    if (formCode.code.trim() !== "") {
      const token = await recaptchaRef.current.executeAsync();
      recaptchaRef.current.reset();
      if (!token) {
        setMensaje("Captcha inválido, actualizar web");
        return;
      }

      setSpinner(true);

      let objUsuario = {
        id: formCode.id,
        code: formCode.code,
        tokenCaptcha: token,
      };

      try {
        const res = await sendCode(objUsuario, urlApi);

        // console.log({ res })
        setSpinner(false);
        if (res.codigo === 0) {
          setMensaje("");
          setErrorData(false);
          setCount(3);
        } else {
          setMensaje("Código inválido");
          setErrorData(true);
        }
      } catch (err) {
        setMensaje(err);
        setErrorData(true);
        setSpinner(false);
      }
    } else {
      setMensaje("Debes proporcionar un código.");
    }
  };

  const reenviarCodigo = async () => {
    const token = await recaptchaRef.current.executeAsync();
    recaptchaRef.current.reset();
    if (!token) {
      setMensaje("Captcha inválido, actualizar web");
      return;
    }

    setSpinner(true);

    let objUsuario = {
      identificacion: form.identificacion,
      tokenCaptcha: token,
    };

    try {
      const res = await recovery(objUsuario, urlApi);

      // console.log({ res })
      setSpinner(false);
      if (res.codigo === 0) {
        setMensaje("Se ha reenviado el código.");
        setErrorData(false);
        setFormCode({ ...formCode, id: res.data, tokenCaptcha: token });

        setCount(2);
        return;
      } else if (res.codigo === 1) {
        if (res.mensaje === "No se validó el captcha") {
          setMensaje(res.mensaje);
        } else {
          setMensaje("Usuario no encontrado.");
        }
      } else {
        if (res.mensaje === undefined) {
          setMensaje(res.Message);
        } else {
          setMensaje(res.mensaje);
        }
      }
      setErrorData(true);
    } catch (err) {
      setMensaje(err);
      setErrorData(true);
      setSpinner(false);
    }
  };

  const handleChangeCode = (e) => {
    setFormCode({
      ...formCode,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <>
      <div className="body__login">
        <h2>Código de verificación</h2>
        <p>
          Ingresa tu código de verificación que se ha enviado a tu teléfono
          celular o correo electrónico para recuperar la contraseña.
        </p>
        {errorData && (
          <div className="error__box">
            <div className="texto__error">
              <p>{mensaje}</p>
            </div>
          </div>
        )}
        <Form
          autoComplete="off"
          onSubmit={(e) => {
            e.preventDefault();
          }}
          className="form__modal"
        >
          <div className="row justify-content-center">
            <div className="col-12">
              <input
                type="text"
                className="form-control border-input "
                id="code"
                name="code"
                placeholder="CÓDIGO"
                autoComplete="off"
                value={formCode.code}
                onChange={handleChangeCode}
              />
            </div>
            <div
              style={{ textAlign: "center" }}
              className="col-12 mt-3 pt-5 mb-4"
            >
              <ReCAPTCHA
                ref={recaptchaRef}
                size="invisible"
                sitekey={codRecaptcha}
              />
              <button className="btn__azul" onClick={handleSubmitCodigo}>
                VALIDAR
              </button>
            </div>
          </div>
        </Form>
        <div className="div__reenviar__codigo">
          <p>
            ¿No recibiste el código?{" "}
            <span
              style={{ color: "var(--rojo)", textDecoration: "underline" }}
              onClick={reenviarCodigo}
            >
              <b>Reenviar código</b>
            </span>
          </p>
        </div>
      </div>
    </>
  );
};

export default SidebarPasswordCodigo;
